import { jsx as _jsx } from "react/jsx-runtime";
import YesNoSingleSelect from '../select/YesNoSingleSelect';
export var FilterYesNoSelect = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, placeholder = _a.placeholder, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(YesNoSingleSelect, { value: activeFilters[item], onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value, _a));
            }, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label })),
    });
};
